import { Box, CircularProgress } from "@mui/material";

import variables from "../../../../assets/styles/_variables.module.scss";
const Pending = ({ phrase }: { phrase: string }) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            <span>{phrase}</span>
            <CircularProgress
                sx={{
                    color: variables["primary-purple"],
                }}
            />
        </Box>
    );
};

export default Pending;
